import { PasswordField, TextField } from '@frontend/mui'
import { ReactNode } from 'react'
import { FakeField } from './fake'
import { useIntl } from '@frontend/t7nd'

export const AccountFieldMessages = {
  ACCOUNT: {
    id: '账号',
    defaultMessage: '账号',
  },
  ACCOUNT_PLACEHOLDER: {
    id: '请输入账号/手机号/邮箱',
    defaultMessage: '请输入账号/手机号/邮箱',
  },
  PASSWORD: {
    id: '密码',
    defaultMessage: '密码',
  },
} as const

export function AccountFields({ forget }: { forget?: ReactNode }) {
  const { formatMessage } = useIntl()

  return (
    <>
      <FakeField />
      <TextField
        name="account"
        label={formatMessage(AccountFieldMessages.ACCOUNT)}
        placeholder={formatMessage(AccountFieldMessages.ACCOUNT_PLACEHOLDER)}
        required
      />
      <PasswordField
        name="password"
        label={formatMessage(AccountFieldMessages.PASSWORD)}
        required
        helperText={forget}
      />
    </>
  )
}
